import React, { FC, ReactNode } from 'react';
import clsx from 'clsx';
import { UploadBoxView } from './UploadBox.view';
import { SelectedFileView } from './SelectedFiles.view';

type UploadFileBoxProps = {
  className?: string;
  hasError?: boolean;
  progress?: number;
  onAttach: (file: File) => void;
  file?: File | null;
  acceptFile?: string;
  description?: ReactNode;
};

export const UploadFileBox: FC<UploadFileBoxProps> = ({
  hasError,
  file,
  progress,
  onAttach,
  acceptFile,
  className,
  description,
}) => {
  return (
    <div data-testid='UploadFileBox' className={clsx('mb-4 mt-1')}>
      {!file && (
        <UploadBoxView
          hasError={hasError}
          onAttach={onAttach}
          acceptFile={acceptFile}
          className={className}
          description={description}
        />
      )}
      {!!file && <SelectedFileView progress={progress} file={file} />}
    </div>
  );
};
